import React from "react";

import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Gallery } from "@/components/Gallery";
import { Awards } from "@/components/Awards";
import { Pricing } from "@/components/Pricing";
import Contact from "@/components/Contact";
//import { Contact } from "@/components/Contact"; // uses the updated Contact form (invisible reCAPTCHA + POST to /api/contact)
import { Footer } from "@/components/Footer";
import { themes } from "@/theme/themes"; // fallback to file-based production


const Index: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main id="main" className="flex-1">
        <Hero />
        <About />
        <Gallery />
        <Awards />
        <Pricing />
        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
